import { ucEndpoints } from "../../config/config";
import { AppDispatch } from "../../reducers";
import {
  getPublicRolesFailure,
  getPublicRolesStart,
  getPublicRolesSuccess
} from "../../store/publicRoles";
import { getErrorMessageFromRequest } from "../../utils/utils";
import { apiCallBegan } from "../middlwares/api";

/**
 * Get public roles
 */
export const getPublicRoles = () => async (dispatch: AppDispatch) => {
  dispatch(
    apiCallBegan({
      url: ucEndpoints.publicRoles,
      method: "get",
      onStart: getPublicRolesStart,
      onSuccess: getPublicRolesSuccess,
      onFailure: (error: any) => (dispatch: AppDispatch) =>
        dispatch(getPublicRolesFailure(getErrorMessageFromRequest(error)))
    })
  );
};
